/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { ActionRequest } from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { all, put, takeLeading } from 'redux-saga/effects';
import * as Context from '../context';

export enum ActionType {
  REQUEST = 'programInfo/clear',
}

// ACTIONS
type ClearContext = ActionRequest<ActionType.REQUEST, Context.PiContext>;

type Actions = ClearContext;

const Actions = {
  request: (context: Context.PiContext): ClearContext => ({
    type: ActionType.REQUEST,
    meta: context,
  }),
};

export const Creators = { request: Actions.request };

function* requestSaga(action: ClearContext): SagaIterator {
  yield put(Context.ActionCreators.clear(action.meta));
}

export function* saga(): SagaIterator {
  yield all([takeLeading(ActionType.REQUEST, requestSaga)]);
}
